import React, { useState } from "react";
import { Select, MenuItem, InputLabel, makeStyles, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  textField: {
    textAlign: 'left',
    width: '100%',
  }
}));

// NOTE // takes in a defaultVal (the value it's changing), handleChange (the state-management function), inputLabel, items, and multiple (set to true for multiple, ignore or set to false for single choice)
// NOTE // (e.g.) <SelectWithLabel defaultVal={depAirport} handleChange={changeAirportRq} inputLabel={'Airport'} items={airNorthAirports}/> 
export const SelectWithLabel = (props) => {
  let defaultVal = props.defaultVal
  let handleChange = props.handleChange
  let inputLabel = props.inputLabel
  // NOTE // items should be an array of objects with a label and value (e.g. [{label: 'none', value: null}, {label: 'active', value: true}])
  let items = props.items
  let multiple = props.multiple
  let customStyle = props.customStyle
  let disabled = props.disabled ? props.disabled : false

  const classes = useStyles();
  const id = inputLabel.toLowerCase().replaceAll(' ', '-')
  //state for handle open or close  the dropdown
 const [open, setOpen] = useState(false);


 const handleSelectChange = (event) => {
   handleChange(event);
   setOpen(false); // close the dropdown
 };

 //  when the dropdown is opened
 const handleSelectOpen = () => {
   setOpen(true);
 };
  return (
    <Grid container justifyContent="center" style={customStyle || {}}>
      <Grid container justifyContent="center" item xs={12}>
        {/* NOTE // neeeded to use in-line styling to override textAlign */}
        <InputLabel className={classes.textField} shrink id={id + '-label-placeholder'}>{inputLabel}</InputLabel>
      </Grid>
      <Grid container justifyContent="center" item xs={12}>
      <Select
          labelId={id + '-label'}
          id={id}
          value={defaultVal}
          onChange={handleSelectChange}
          onOpen={handleSelectOpen}
          onClose={() => setOpen(false)} // close the dropdown on selection
          displayEmpty
          className={classes.textField}
          multiple={multiple ? true : false}
          disabled={disabled}
          open={open} // open state of the dropdown
        >
          {items.map((item, index) => (
            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
          ))}
        </Select>
      </Grid>
    </Grid>
  )
}